// Helpers de las Órdenes de servicio.

export const ESTADOS_ORDEN = [
  { clave: 'pendiente', nombre: 'Pendiente', color: '#B45309', bg: '#FEF3C7', emoji: '🕒' },
  { clave: 'en_proceso', nombre: 'En proceso', color: '#1D4ED8', bg: '#DBEAFE', emoji: '🔧' },
  { clave: 'entregado', nombre: 'Entregado', color: '#047857', bg: '#D1FAE5', emoji: '✅' },
  { clave: 'cancelada', nombre: 'Cancelada', color: '#B91C1C', bg: '#FEE2E2', emoji: '✖️' },
];

export function estadoOrdenInfo(clave) {
  return ESTADOS_ORDEN.find((e) => e.clave === clave) || ESTADOS_ORDEN[0];
}
